<template>
  <div>
    <Button type="primary" @click="createLevel">新增等级</Button>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/oto/teacher/index"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="none"
        keyField="id"
        method="get"
        :allowPage="false"
      >
        <template slot-scope="{ row }" slot="c1">
          <Avatar :src="row.level_avatar" v-if="row.level_avatar" />
          <span>{{row.level_name}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="text" size="small" @click="editLevel(row)">编辑-</Button>
          <Button type="text" size="small" @click="deleteLevel(row.id)">删除</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showCreateLevel" title="教师等级" width="600" scrollable>
      <Form ref="levelForm" :rules="ruleValidate" :model="levelInfo" :label-width="120">
        <FormItem label="等级名称" prop="level_name">
          <Input
            style="width:300px"
            type="text"
            v-model="levelInfo.level_name"
            placeholder="请输入等级名称"
            :maxlength="50"
          />
        </FormItem>
        <FormItem label="等级头像" prop="level_avatar">
          <Avatar :src="levelInfo.level_avatar" v-if="levelInfo.level_avatar" />
          <UploadImage
            @onSuccess="uploadSuccess"
            :primary="false"
            url="/api/public/img"
            :format="['jpg','jpeg','png','gif']"
            label="上传头像"
          ></UploadImage>
        </FormItem>
        <FormItem label="课时收费" prop="section_price">
          <Input
            style="width:150px"
            type="number"
            v-model="levelInfo.section_price"
            placeholder="请输入课时收费"
            :maxlength="50"
          />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showCreateLevel=false">取消</Button>
        <Button type="primary" size="large" @click="submitForm('levelForm')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import UploadImage from "@/components/UploadFile.vue";

export default {
  name: "TeachOtoLevel",
  components: {
    UploadImage
  },
  data() {
    return {
      showCreateLevel: false,
      columns: [
        {
          title: "分类名称",
          slot: "c1",
          key: "level_name"
        },
        {
          title: "课时收费",
          key: "section_price"
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center",
          fixed: "right"
        }
      ],
      searchCondition: {},
      selectList: [],
      levelInfo: {
        id: "",
        level_name: "",
        level_avatar: "",
        section_price: ""
      },
      ruleValidate: {
        level_name: [
          {
            required: true,
            message: "等级名称不能为空",
            trigger: "blur"
          }
        ],
        level_avatar: [
          {
            required: true,
            message: "等级头像不能为空",
            trigger: "change"
          }
        ],
        section_price: [
          {
            required: true,
            message: "课时收费不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  async created() {},
  methods: {
    rowsFormatter(rows) {
      rows.forEach(row => {
        row.section_price = row.section_price / 100;
      });
    },
    onSelectionChange(val) {
      this.selectList = val;
    },
    uploadSuccess(data) {
      this.levelInfo.level_avatar = data.path;
    },
    createLevel() {
      this.showCreateLevel = true;
      this.levelInfo.id = "";
      this.levelInfo.level_name = "";
      this.levelInfo.level_avatar = "";
      this.levelInfo.section_price = "";
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {};
        data.level_name = this.levelInfo.level_name;
        data.level_avatar = this.levelInfo.level_avatar;
        data.section_price = this.levelInfo.section_price;
        if (this.levelInfo.id) {
          data.id = this.levelInfo.id;
        }
        if (!data.id) {
          await this.$http.post("/api/oto/teacher/create", data);
        } else {
          await this.$http.put("/api/oto/teacher/update", data);
        }
        this.$refs.grid.refresh();
        this.showCreateLevel = false;
      });
    },
    async deleteLevel(id) {
      await this.$promiseConfirm("确定要删除该分类吗？");
      await this.$http.delete("/api/oto/teacher/" + id);
      this.$refs.grid.refresh();
    },
    async editLevel(data) {
      this.showCreateLevel = true;
      this.levelInfo.id = data.id;
      this.levelInfo.level_name = data.level_name;
      this.levelInfo.level_avatar = data.level_avatar;
      this.levelInfo.section_price = data.section_price.toString();
    }
  }
};
</script>